import {Carrello} from '../models/carrello';
export class Ordine {
    note: string;
    totale: number;
    codice: string;
    confermato: boolean;
    righe: Array<Carrello>;
    importazione: Array<Carrello>;
    aggiornaTotale(): void {
        let totale:number;
        for (var i=0; i<this.righe.length; i++){
            let x:Carrello=this.righe[i];
            totale=totale+(x.qta*x.prezzo);
        }
        this.totale=totale;
        console.log("totale "+totale);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ordine.ts